/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancerPricingResource
 */
export interface FreelancerPricingResource {
    /**
     * 
     * @type {number}
     * @memberof FreelancerPricingResource
     */
    dailyRate: number;
    /**
     * 
     * @type {string}
     * @memberof FreelancerPricingResource
     */
    currencyCode: string;
}

/**
 * Check if a given object implements the FreelancerPricingResource interface.
 */
export function instanceOfFreelancerPricingResource(value: object): value is FreelancerPricingResource {
    if (!('dailyRate' in value) || value['dailyRate'] === undefined) return false;
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    return true;
}

export function FreelancerPricingResourceFromJSON(json: any): FreelancerPricingResource {
    return FreelancerPricingResourceFromJSONTyped(json, false);
}

export function FreelancerPricingResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerPricingResource {
    if (json == null) {
        return json;
    }
    return {
        
        'dailyRate': json['dailyRate'],
        'currencyCode': json['currencyCode'],
    };
}

export function FreelancerPricingResourceToJSON(value?: FreelancerPricingResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'dailyRate': value['dailyRate'],
        'currencyCode': value['currencyCode'],
    };
}

